import { formatPaginatedResponseItems, formatRequestOptions, formatSubCategory } from "../format";
import useRequest from "~/hooks/use-request";
import EventsAPI from "~/services/events";

const SubCategoriesAPI = {
  load(options: IRequestPaginatedOptions & { mainCategoryId?: string }): Promise<IPaginatedResponse<IModelSubCategory>> {
    const { request } = useRequest();
    const params = formatRequestOptions(options);

    if (options.mainCategoryId) {
      params.sort = `media_parent_order.${options.mainCategoryId}`;
      // @ts-expect-error FIXME:
      params.filters = { identityId: options.mainCategoryId, media_type: "identity_item" };
    }

    return request
      .post<IPaginatedResponse<IResponseCategory>>("/api/identity/list", { body: params })
      .then(response => formatPaginatedResponseItems(response, formatSubCategory));
  },

  loadAllSubCategory(): Promise<IPaginatedResponse<IModelSubCategory>> {
    const { request } = useRequest();
    const params = { filters: { media_type: "identity_item" }, page: 0, size: 100 };

    return request
      .post<IPaginatedResponse<IResponseCategory>>("/api/identity/list", { body: params })
      .then(response => formatPaginatedResponseItems(response, formatSubCategory));
  },

  async loadById(subCategoryId: string, options?: { mainCategoryId: string; loadTotals: boolean }): Promise<IModelSubCategory> {
    const { request } = useRequest();

    return await request
      .get<IContentResponse<IResponseCategory>>(`/api/identity/get_by_id/id/${subCategoryId}`, { setAuthorization: true })
      .then(async (res) => {
        const subCategory = formatSubCategory(res.content);

        if (options?.loadTotals) {
          const params = { countOnly: true, subCategoryId, mainCategoryId: options.mainCategoryId };

          await Promise.all([
            EventsAPI.load({ ...params, type: "archived" }), // latest events
            EventsAPI.load({ ...params, type: "upcoming" }), // upcoming events
            EventsAPI.load({ ...params, type: "live" }), // live events
          ]).then(([res1, res2, res3]) => {
            subCategory.totalVodEventsNumber = res1.content.count;
            subCategory.totalUpcomingEventsNumber = res2.content.count;
            subCategory.totalLiveEventsNumber = res3.content.count;
            subCategory.totalEventsNumber = subCategory.totalVodEventsNumber + subCategory.totalUpcomingEventsNumber + subCategory.totalLiveEventsNumber;
          });
        }

        return subCategory;
      });
  },
};

export default SubCategoriesAPI;
